<template>
  <transition name="vr360-modal" v-if="modal.show">
    <div class="vr360-modal" @click="closeOutside($event)">
      <div class="vr360-block vr360-modal__wrapper">
        <div class="vr360-flex-column vr360-modal__cont" ref="container">
          <slot></slot>
            <button v-if="params.closeBtn" class="modal__close-btn" type="button" @click.stop="closeModal">
              <i class="icons bg-close-btn"></i>
            </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "modal",
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      hideModal: "hideModal"
    }),
    closeOutside(e) {
      if (this.$refs.container && !this.$refs.container.contains(e.target)) {
        this.hideModal();
      }
    },
    closeModal() {
      this.hideModal();
    }
  },
  computed: {
    ...mapGetters({
      modal: "modal"
    })
  }
};
</script>

<style lang='scss'>
</style>
